//--------------------------------------------------------------------//
//******************** agents server request helpers ******************//
//--------------------------------------------------------------------//
// Shared low-level fetch helpers for talking to the agents server.
// Used by AgentsService and by the per-tab services (skills, scheduling).
import { GUDHUB_SETTINGS } from '../../config.js';

// Retrieves current user auth data (token, user_id, auth_key) for API requests.
export async function getAuthData() {
    const token = await gudhub.getToken();
    const user = gudhub.storage.getUser();

    return {
        token,
        user_id: user.user_id,
        auth_key: user.auth_key
    };
}

// Sends an authenticated request to the agents server. Appends access_token to the
// POST body, or to the URL as a query param for GET (which has no body).
export async function request(endpoint, data = {}, method = 'POST') {
    const authData = await getAuthData();
    let url = GUDHUB_SETTINGS.agents_server_url + endpoint;

    const options = {
        method,
        headers: { 'Content-Type': 'application/json' }
    };

    if (method !== 'GET') {
        options.body = JSON.stringify({
            ...data,
            access_token: authData.token
        });
    } else {
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}access_token=${encodeURIComponent(authData.token)}`;
    }

    const response = await fetch(url, options);
    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.error || result.message || 'Agents service request error');
    }

    return result;
}
